import { memo, useMemo, useState } from "react";
import ImportComponent from "./ImportComponent";
import { IJsonArr, downloadCSV } from "src/utils/utils";
import {
  CategoryOptionType,
  InternalPaymentRecordInput,
  PaymentRecordJsonArrInput,
  useGetCategoryOptionManyQuery,
  useMigratePaymentRecordsMutation,
  usePaymentRecordSampleCsvLazyQuery,
} from "src/generated/graphql";
import { MESSAGES, MigrationModalStyle } from "src/utils/constants";
import { errorNotification } from "src/utils/alerts";
import { migrateErrors } from "./migrateMessage";
import { closeAllModals, openModal } from "@mantine/modals";
import RelationMappingTool, {
  IDereferenceField,
  IMappingOption,
} from "./RelationMapping";
import { useAppContext } from "src/api/AppContext";

type IPaymentHistoryImports = {
  locId: string;
};

function PaymentHistoryImports({ locId }: IPaymentHistoryImports) {
  const { currentOrganization } = useAppContext();
  const [revenueArr, setrevenueArr] = useState<IMappingOption[]>([]);
  const [getSampleCsv, { loading: isCsvDownloading }] =
    usePaymentRecordSampleCsvLazyQuery();

  const { loading: categoryLoading } = useGetCategoryOptionManyQuery({
    onCompleted(data) {
      let _data = data?.categoryOptionMany;
      let _dataRevenue =
        _data
          ?.filter((e) => e.type === CategoryOptionType.Revenue)
          .map((val) => ({
            value: val.id,
            label: val.name,
          })) || [];
      setrevenueArr(_dataRevenue);
    },
    variables: { orgId: currentOrganization?.id || "" },
    skip: !currentOrganization?.id,
  });
  const isDisabled = !revenueArr.length;

  const [migrateRecords, { loading: uploadloading }] =
    useMigratePaymentRecordsMutation();

  const fields: IDereferenceField[] = useMemo(
    () => [
      {
        csvColumnHeader: "Revenue Category",
        fieldName: "RevenueCat",
        required: true,
        options: revenueArr,
      },
    ],
    [revenueArr]
  );

  const onUpload = async (jsonArr: IJsonArr) => {
    const paymentsJsonArrInput: PaymentRecordJsonArrInput = {
      data: jsonArr as InternalPaymentRecordInput[],
    };

    const openModalSelect = () => {
      const onSubmit = async () => {
        try {
          closeAllModals();
          const { data } = await migrateRecords({
            variables: { data: paymentsJsonArrInput, locationId: locId },
          });
          data && migrateErrors(data.migratePaymentRecords.errors);
        } catch (err) {
          errorNotification({ message: MESSAGES.INVALID_CSV });
        }
      };

      openModal({
        ...MigrationModalStyle,
        closeOnClickOutside: false,
        title: "Payment History Mapping",
        children: (
          <RelationMappingTool
            csvData={jsonArr}
            onSubmit={onSubmit}
            fields={fields}
          />
        ),
      });
    };
    openModalSelect();
  };

  const onDownload = async () => {
    const { data } = await getSampleCsv();
    downloadCSV(data?.paymentRecordSampleCSV, "Payment_History_Sample.csv");
  };
  return (
    <>
      <ImportComponent
        title="Step 3 - Payment History Import"
        onDownload={onDownload}
        onUpload={onUpload}
        loading={isCsvDownloading}
        uploadloading={uploadloading}
        disabled={isDisabled}
        bannerContent={
          isDisabled && !categoryLoading
            ? "Requires at least 1 Revenue Category to generate"
            : ""
        }
      />
    </>
  );
}

export default memo(PaymentHistoryImports);
